import { useEffect, useState } from "react";
import AdminNav from "../../components/AdminNav";
import { getAdminClaims, updateClaimStatus } from "../../api/client";
import LoadingIndicator from "../../components/LoadingIndicator";

export default function AdminClaims() {
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [notes, setNotes] = useState({});
  const [busyId, setBusyId] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await getAdminClaims();
      setClaims(data);
    } catch {
      setError("Failed to load claims");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleUpdateStatus = async (claimId, newStatus) => {
    setError("");
    setBusyId(claimId);
    try {
      const resNotes = notes[claimId] || "";
      await updateClaimStatus(claimId, newStatus, resNotes);
      await load();
    } catch (err) {
      setError(err.response?.data?.error || "Failed to update claim");
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div className="admin-app">
      <AdminNav />
      <div className="page wide page-with-nav">

      <div className="brand-header">
        <span className="brand-logo">🛡️</span>
        <span className="brand-name">Insurance Claims Review</span>
        <p className="brand-tagline">Review and settle package protection insurance claims</p>
      </div>

      {error && <p className="error">{error}</p>}

      {loading ? (
        <LoadingIndicator label="Loading claims..." />
      ) : claims.length === 0 ? (
        <div className="empty-state">
          <span className="empty-state-icon">✅</span>
          <p className="empty-state-text">No insurance claims submitted.</p>
        </div>
      ) : (
        claims.map(c => (
          <div key={c._id} className="rider-card" style={{ marginBottom: "16px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
              <div>
                <strong>Claim #{c._id.slice(-6).toUpperCase()}</strong>
                <p style={{ fontSize: "12px", color: "var(--text-muted)", marginTop: "2px" }}>
                  Submitted: {new Date(c.createdAt).toLocaleString()}
                </p>
              </div>
              <span className={`status-badge ${c.status === "approved" || c.status === "paid" ? "info" : c.status === "denied" ? "danger" : "warning"}`}>
                {c.status.replace(/_/g, " ").toUpperCase()}
              </span>
            </div>

            <div className="info-row">
              <span className="label">Customer</span>
              <span className="value">{c.user?.name} ({c.user?.email})</span>
            </div>
            <div className="info-row">
              <span className="label">Declared Value</span>
              <span className="value">₦{c.declaredValue?.toLocaleString()}</span>
            </div>
            <div className="info-row">
              <span className="label">Claimed Amount</span>
              <span className="value" style={{ color: "var(--text-accent)", fontWeight: 700 }}>₦{c.claimAmount?.toLocaleString()}</span>
            </div>
            <div className="info-row">
              <span className="label">Reason</span>
              <span className="value">{c.reason}</span>
            </div>

            <div style={{ marginTop: "12px" }}>
              <input
                type="text"
                placeholder="Resolution / Auditor Notes"
                value={notes[c._id] || ""}
                onChange={e => setNotes({ ...notes, [c._id]: e.target.value })}
                style={{ marginBottom: "8px" }}
              />
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                <button
                  style={{ width: "auto", padding: "4px 12px", fontSize: "12px", marginTop: 0 }}
                  disabled={busyId === c._id}
                  onClick={() => handleUpdateStatus(c._id, "under_review")}>
                  Under Review
                </button>
                <button
                  style={{ width: "auto", padding: "4px 12px", fontSize: "12px", marginTop: 0 }}
                  disabled={busyId === c._id}
                  onClick={() => handleUpdateStatus(c._id, "approved")}>
                  Approve Claim
                </button>
                <button
                  style={{ width: "auto", padding: "4px 12px", fontSize: "12px", marginTop: 0, background: "rgba(22, 199, 132, 0.2)", color: "var(--success)", borderColor: "var(--success)" }}
                  disabled={busyId === c._id}
                  onClick={() => handleUpdateStatus(c._id, "paid")}>
                  Mark Paid Out
                </button>
                <button
                  className="secondary"
                  style={{ width: "auto", padding: "4px 12px", fontSize: "12px", marginTop: 0, color: "var(--danger-hover)" }}
                  disabled={busyId === c._id}
                  onClick={() => handleUpdateStatus(c._id, "denied")}>
                  Deny Claim
                </button>
              </div>
            </div>
          </div>
        ))
      )}
      </div>
    </div>
  );
}
